import { useAmp } from 'next/amp'
import config from '@public-config'

function GoogleAnalyticsScriptAmp() {
  const isAmp = useAmp()

  if (!isAmp) return null

  return <amp-analytics config={config.ampAnalyticsConfig} data-credentials="include" />
}

export default GoogleAnalyticsScriptAmp
